<footer id="footer">
  <div class="layout layout_one_up" [ngClass]="{'footer-column-dir' : isMobileDeviceSize}">
    <div class="footer-contents">
      <ul class="clean-list">
        <li class="footer-link"><a href="https://www.ama-assn.org/terms-use">Terms of Use</a></li>
        <li class="footer-link"><a href="https://www.ama-assn.org/privacy-policy">Privacy Policy</a></li>
        <li class="footer-link"><a href="https://www.ama-assn.org/code-conduct">Code of Conduct</a></li>
        <li class="footer-link"><a href="https://www.ama-assn.org/accessibility-statement">Website Accessibility</a></li>
        <li class="footer-link"><a href="https://www.ama-assn.org/accessibility-statement">Cookie Settings</a></li>
        <li class="footer-text">&copy; Copyright 1995 - {{ copyrightYear }} American Medical Association. All rights reserved.</li>
      </ul>
    </div>
      <ng-container *ngIf="isMobileDeviceSize">
        <div class="mobile-footer-spacer"></div>
        <div class="footer-links-mobile">
          <ng-container *ngFor="let link of navigationLinks">
            <div class="footer-link" *ngIf="link.isFooterLink">
              <app-navigation-mobile-link
              [navigationLink]="link"
              [externalLink]="isExternalLink(link)"
              [forceReload]="shouldForceReload(link)"
              [opened]="false"
              ></app-navigation-mobile-link>
            </div>
          </ng-container>
        </div>
      </ng-container>
  </div>
</footer>
